import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import Aura from '@primeuix/themes/aura';
// import Lara from '@primeuix/themes/lara';
// import Material from '@primeuix/themes/material';
// import Nora from '@primeuix/themes/nora';
import { ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { environment as env } from '../environments/environment';
import { okta } from '../environments/okta';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptor/auth';
import { ConfigService } from './shared/services/config.service';
import { VideoService } from './shared/services/video.service';
import { MessageService } from 'primeng/api';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import adapter from 'webrtc-adapter';
import { provideQuillConfig } from 'ngx-quill/config';

if (env.production) {
  enableProdMode();
}

const oktaAuth = new OktaAuth({
  issuer: env.oktaIssuer,
  clientId: okta.clientId,
  redirectUri: env.loginCallback,
  postLogoutRedirectUri: env.logoutCallback,
  scopes: ['openid', 'email', 'groups', 'profile'],
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, google, tailwind-utilities, custom',
          },
        },
      },
      ripple: true,
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(OktaAuthModule),
    ConfigService,
    VideoService,
    ConfirmationService,
    MessageService,
    provideQuillConfig({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          ['link'],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ],
      },
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth },
    },
  ],
};
